import React from 'react'
import './index.css'
import { fdiToPalmer, fdiSelectedSet } from '../../configTools/toothNumbering'

// Full 32-tooth chart for the printed order label, drawn as inline SVG.
//
// SVG rather than HTML+CSS for one decisive reason: selected teeth are FILLED, and a CSS
// background-color is dropped whenever "Background graphics" is unchecked in the print dialog
// (print-color-adjust:exact does not override that checkbox). A filled CSS circle would print
// as white-on-white. An SVG `fill` is foreground content, so it always prints. Vector also
// means crisp circles at the printer's 203 dpi instead of an upscaled bitmap.
//
// It also shows EVERY tooth with the selected ones marked, rather than listing only the
// selected numbers the way the job cards do, so the height never depends on the selection and
// can never wrap onto a second sticker.
//
// Orientation is standard FDI: the patient's RIGHT is drawn on the LEFT.
//   quadrant 1 = upper right, 2 = upper left, 3 = lower left, 4 = lower right
// Each row runs [right quadrant, distal->midline] | [left quadrant, midline->distal]. Note the
// lower arch is the mirror of the job cards', which place quadrant 3 bottom-left - a known
// defect there, not here.
const UPPER_FDI = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
const LOWER_FDI = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

// SVG user units. The stylesheet scales the whole thing to 216pt wide, so these are relative.
const CELL = 12;
const RADIUS = 5.2;
const ROW_H = 13;
const COLS = 16;
const WIDTH = CELL * COLS;          // 192
const HEIGHT = ROW_H * 2;           // 26
const MIDLINE_X = CELL * 8;         // 96 - between the two quadrants

const Index = ({ lineItems }) => {
    const selected = fdiSelectedSet(lineItems);
    const tooth = (fdi, index, rowIndex) => {
        const on = selected.has(fdi);
        const cx = index * CELL + CELL / 2;
        const cy = rowIndex * ROW_H + ROW_H / 2;
        return (
            <g key={fdi}>
                <circle
                    cx={cx} cy={cy} r={RADIUS}
                    fill={on ? '#000' : '#fff'}
                    stroke='#000'
                    strokeWidth={0.7}
                />
                <text
                    x={cx} y={cy}
                    textAnchor='middle'
                    dominantBaseline='central'
                    fontSize={7}
                    fontWeight={on ? 700 : 400}
                    fill={on ? '#fff' : '#000'}
                >{fdiToPalmer(fdi)}</text>
            </g>
        );
    };
    return (
        <div className='nv-lbl-chart'>
            <div className='nv-lbl-chart__sides'>
                <span>Right</span>
                <span>Left</span>
            </div>
            {/* No shapeRendering=crispEdges here: it disables anti-aliasing, which is right for
                the QR's axis-aligned squares but makes circles visibly jagged. */}
            <svg
                className='nv-lbl-chart__svg'
                viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
                xmlns='http://www.w3.org/2000/svg'
            >
                <line x1={MIDLINE_X} y1={0} x2={MIDLINE_X} y2={HEIGHT} stroke='#000' strokeWidth={0.7}/>
                {UPPER_FDI.map((fdi, i) => tooth(fdi, i, 0))}
                {LOWER_FDI.map((fdi, i) => tooth(fdi, i, 1))}
            </svg>
        </div>
    )
}

export default Index
